import { render, staticRenderFns } from "./DoctorForeverReward.vue?vue&type=template&id=c2e6270e&scoped=true"
import script from "./DoctorForeverReward.vue?vue&type=script&lang=js"
export * from "./DoctorForeverReward.vue?vue&type=script&lang=js"
import style0 from "./DoctorForeverReward.vue?vue&type=style&index=0&id=c2e6270e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e6270e",
  null
  
)

export default component.exports